function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJira = function SvgJira(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#036",
    d: "M16.17 17.72c1.1-1.03 5.36-5.23 6.14-8.6 0 0 2.72-.05 4.6-1.57 0 0 1.02-.64 1.02.53 0 0 .22 4.93-6.87 11.88l-1.16 1.17c4.2 5.06 3.9 10.42 3.9 10.42h-5.17c.4-1.95-.42-4.78-7.5-11.74-7.1-6.94-6.86-11.72-6.86-11.72 0-1.17 1-.56 1-.56 1.9 1.5 4.6 1.5 4.6 1.5.83 3.6 5.56 8.02 6.3 8.7v-.01zm-1 8.95c-1.66 2.46-1.85 3.98-1.62 5.18H8.4s-.27-4.67 3.02-9.4c1.6 1.65 2.83 3.03 3.75 4.22zM13.5 9.47h5.1s.67-.1.5.8c-.22 1.24-2.98 3.8-2.98 3.8s-2.02-1.88-2.9-3.64c0 0-.38-.96.28-.96zm11.55-5.28c0 1.22-1 2.22-2.23 2.22s-2.23-1-2.23-2.23c0-1.25 1-2.25 2.22-2.25 1.23 0 2.23 1 2.23 2.24l.01.02zm-13.14 0c0 1.22-1 2.22-2.22 2.22-1.24 0-2.24-1-2.24-2.23 0-1.25 1-2.25 2.24-2.25 1.23 0 2.23 1 2.23 2.24l-.01.02zm6.7-1.82c0 1.23-1 2.23-2.22 2.23-1.24 0-2.24-1-2.24-2.22 0-1.23 1-2.23 2.24-2.23 1.23 0 2.23 1 2.23 2.23l-.01-.01z",
    style: {
      fill: "#036"
    }
  })));
};
export default SvgJira;